export default {
  content: ''
};
